/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type ContractContractType = typeof ContractContractType[keyof typeof ContractContractType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractContractType = {
  FIXED: 'FIXED',
  FRAMEWORK: 'FRAMEWORK',
} as const;
